var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DistintaMultilevel',{staticClass:"ma-5",staticStyle:{"border-radius":"0px"},on:{"go_back":_vm.goBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }